import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const block = 'railContainer';

const RailContainer = ({ children, className, ...rest }) => (
  <div className={classNames(block, 'rail__container', className)} {...rest}>{children}</div>
);

RailContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

RailContainer.defaultProps = {
  children: null,
  className: null,
};

export default RailContainer;
